// Matching values from next.config.js
export const deviceSizes = [480, 640, 750, 828, 1080, 1200, 1440, 1920, 2560] as const;
type DeviceSize = (typeof deviceSizes)[number];

export const deviceSizeMap = deviceSizes.reduce(
    (acc, size) => {
        acc[size] = size;
        return acc;
    },
    {} as Record<DeviceSize, number>
);
